const {Component} = require("react");
const PropTypes = require("prop-types");
const {classList} = require("helpers/html");
const shortid = require("shortid");
const Image = require("components/forms/Image");
const Input = require("components/forms/Input");
const Date = require("components/forms/Date");
const Select = require("components/forms/Select");
const env = require("services/env");
const moment = require("moment");

class Subusers extends Component {

	static get propTypes() {
		return {
			value: PropTypes.array,
			defaultValue: PropTypes.array,
			error: PropTypes.object,
			openOnload: PropTypes.bool
		};
	}

	static get defaultProps() {
		return {
			openOnload: true,
		}
	}

	constructor(props) {
		super(props);

		this.state = {
			value: props.value || props.defaultValue || [],
			deleted: []
		};

		// Push placeholder value if there are no values
		if (this.state.value.length === 0 && this.props.openOnload) {
			this.state.value.push(this.placeholderRow);
		}
	}

	get placeholderRow() {
		return {
			local_id: shortid.generate(),
			avatar: null,
			level: null,
			name: "",
			birthday: "",
			placeholder: true
		};
	}

	componentWillReceiveProps(props) {

		if (props.value && (props.value instanceof Array)) {
			const {value, deleted} = this.state;
			const newValue = props.value.filter(item => deleted.indexOf(item.id) === -1);
			const currentValue = value.filter(item => item.placeholder !== true);
			let indexShift = 0;

			if (currentValue.length === newValue.length) {
				this.setState({
					deleted: [],
					value: value.map((item, index) => {
						if (item.placeholder) {
							indexShift++;
							return item;
						}

						const newItem = newValue[index - indexShift];
						return item.id === newItem.id ? item : newItem;
					})
				});
			}
			else {
				this.forceUpdate();
			}
		}
	}

	inputName(index, name) {
		if (typeof this.props.name === "string") {
			return `${this.props.name}[${index}][${name}]`;
		}
	}

	error(index, name) {
		return this.props.error[`${index}.${name}`] || null;
	}

	onPropertyChange(index, property, updateValue = true) {
		return (value) => {
			this.setState(state => {
				if (updateValue) {
					state.value[index][property] = value;
				}

				state.value[index].placeholder = false;
				return state;
			});
		};
	}

	onInputChange(index, property, updateValue = true) {
		return e => {
			return this.onPropertyChange(index, property, updateValue)(e.target.value);
		};
	}

	onAddRow = (e) => {
		e.preventDefault();
		e.stopPropagation();

		this.setState(state => {
			state.value.push(this.placeholderRow);
			return state;
		});
	};

	onRemoveRow = (index) => {
		return (e) => {
			e.preventDefault();
			e.stopPropagation();

			this.setState(state => {
				const item = state.value[index];

				if (item.id) {
					state.deleted.push(item.id);
				}

				state.value.splice(index, 1);
				return state;
			});
		}
	};

	get levelsOptions() {
		return [{label: "Vælg...", value: ""}].concat(
			env.get("options.levels", []).map(level => {
				return {
					label: level.name,
					value: level.id
				};
			})
		);
	}

	get maxBirthdayDate() {
		return moment().toISOString();
		// TODO: Add proper limit
		//return moment().subtract(18, "years").toISOString();
	}

	renderRows() {
		return this.state.value.map((item, index) => {
			const key = item.id || item.local_id;
			const hiddenFields = item.placeholder !== true;
			const idMarkup = hiddenFields && item.id ?
				(<input type="hidden" name={this.inputName(index, "id")} value={item.id}/>) : null;

			return (
				<div key={key} className={classList("subuser-row", item.placeholder ? "placeholder-row" : null)}>
					{idMarkup}

					<Image name={this.inputName(index, "avatar")} value={item.avatar ? item.avatar.url : null}
								 handleChange={this.onPropertyChange(index, "avatar", false)}/>

					<div className="subuser-input-wrap">

						<Input label="Navn" name={this.inputName(index, "name")} required={true} error={this.error(index, "name")}
									 defaultValue={item.name || ""} onChange={this.onInputChange(index, "name")}/>

						<Select label="Vælg dit niveau/klassetrin" name={this.inputName(index, "level_id")} required={true}
										error={this.error(index, "level_id")}
										options={this.levelsOptions} defaultValue={item.level ? item.level.id : ""}
										onChange={this.onInputChange(index, "level_id", false)}/>

						<Date label="Fødselsdag" name={this.inputName(index, "birthday")} required={true}
									error={this.error(index, "birthday")} max={this.maxBirthdayDate} value={item.birthday}
									handleChange={this.onPropertyChange(index, "birthday")}/>

						<button type="button" className="subusers-remove-row btn" onClick={this.onRemoveRow(index)}></button>

					</div>
				</div>
			);
		});
	}

	renderHiddenWorkaround() {
		if ((typeof this.props.name === "string") &&
			(this.state.value.filter(item => item.placeholder !== true).length === 0)) {
			return (<input type="hidden" name={`${this.props.name}[]`} value=""/>);
		}
	}

	render() {
		return (
			<div className={classList("subusers-fields", this.props.className)}>
				{this.renderRows()}
				<button type="button" className="campaign-prices-add-row btn btn-primary" onClick={this.onAddRow}>
					Tilføj ny
				</button>
				{this.renderHiddenWorkaround()}
			</div>
		);
	}

}

module.exports = Subusers;



// WEBPACK FOOTER //
// ./resources/js/components/forms/Subusers.js